import mdast from 'mdast';

import { createCodeBlock } from '@lumapps/wrex-code-block/utils/createCodeBlock';
import { DeserializeOptions } from '@lumapps/wrex/serialization/markdown/fromMarkdown/types';

import { createDivider } from '../../utils/createDivider';
import { createHeading } from '../../utils/createHeading';
import { createInlineCode } from '../../utils/createInlineCode';
import { createParagraph } from '../../utils/createParagraph';

export const TYPOGRAPHY_MARKS: DeserializeOptions['marks'] = {
    strong: 'bold',
    emphasis: 'italic',
    delete: 'strikethrough',
};

export const TYPOGRAPHY_ELEMENTS: DeserializeOptions['elements'] = {
    paragraph: {
        convert: (_, children) => createParagraph(children),
    },
    heading: {
        convert: ({ depth }: mdast.Heading, children) => {
            if (!children.length) {
                // Children can't be empty.
                children.push({ text: '' });
            }
            return createHeading(depth, children);
        },
    },
    code: {
        convert: (node) => {
            return createCodeBlock([{ text: node.value }]);
        },
    },
    inlineCode: {
        convert: (node) => {
            return createInlineCode([{ text: node.value }]);
        },
    },
    thematicBreak: {
        convert: () => {
            return createDivider();
        },
    },
};
